<template>
  <div class="flex flex-row pin-t border border-b border-grey-lightest h-12 w-screen shadow z-20 justify-between" >
    <div class="flex flex-row items-center justify-start">
      <div class="no-underline cursor-pointer" @click="goHome()">
        <img class="w-32 ml-4" src="../assets/ekincare_logo.png"/>
      </div>
    </div>
    <div v-if="!isCompanyDoctor && role !== 'specialistDoctor'" class="flex flex-row items-center justify-start">
      <!-- <span class="rounded-full bg-green px-1" /> -->
      <span class="text-lg ml-4" title="Ably Status" v-bind:class="{'text-red': ablyDisconnected, 'text-green font-semibold': ablyConnected}">
        {{ablyStatusText}}
      </span>
      <button v-if="!ablyStatus" @click="connectToAbly" class="hover:bg-grey-lightest bg-white text-blue font-semibold py-2 px-4 rounded">
        Reconnect
      </button>
      <span class="ml-6 mr-4 text-black"> Ready to take Chat? </span>
      <toggle-button @change="updateActiveStatus($event.value)" :value="availableForChat" :sync="true" :labels="{checked: 'Yes', unchecked: 'No'}" :color="{checked: '#3fcb7f', unchecked: '#ff6969'}"/>
    </div>
    <div class="flex flex-row items-center justify-end">
      <span class="ml-4 mr-8">
        <router-link to="/profile" class="no-underline text-black font-semibold">
          {{doctor.name}}
        </router-link>
      </span>
      <span v-if="!isCompanyDoctor" @click="toggleNotification()" class="mr-8 cursor-pointer pt-1 self-center">
        <img class="h-6 w-6 self-center" src="../assets/bell.svg" alt="Notifications">
        <div v-if="notViewedNotificationCount > 0" class="flex bg-red justify-center items-center rounded-full flex-no-grow flex-no-shrink cursor-pointer w-5 h-5 mt-2 ml-3" style="border-radius:50%; position:absolute; top:0px;">
          <p class="flex flex-col self-center justify-center text-xs text-white">{{notViewedNotificationCount}}</p>
        </div>
      </span>
      <span v-if="activeConsultsCount === 0" class="cursor-pointer mr-8 pt-1 self-center" @click="logout">
        <img src="../assets/logout.svg" class="h-6 w-6 self-center">
      </span>
      <span v-else class="flex-no-shrink flex-no-grow relative cursor-pointer mr-8 pt-1 self-center" @click="logoutClicked">
        <img src="../assets/logout.svg" class="h-6 w-6 self-center">
      </span>
      <div v-if="logOut" style="position: fixed; width: 100%; height: 100%; top: 0; left: 0; right: 0; bottom: 0; background-color: rgba(0,0,0,0.5); z-index: 10; cursor: pointer;"></div>
      <div v-if="logOut" class="absolute flex flex-col bg-white shadow rounded-sm h-auto z-20" style="width: 600px; left: calc((100vw - 600px)/2); top:150px;">
          <div class="flex flex-col justify-center px-4 py-2 border-b border-solid border-grey-lightest">
              <div class="flex flex-row mb-2 justify-between items-center">
                  <div class="align-center text-lg text-left font-semibold py-2"> You have {{activeConsultsCount}} active consultations</div>
                  <img @click="closeLogoutOverlay()" class="w-6 h-6 cursor-pointer" src="../assets/close.png">
              </div>
              <label class="text-grey-darker font-light text-xs">Are you sure you want to logout?</label>
              <div class="flex flex-row mt-3 mb-2 justify-start">
                  <div v-on:click="logout()" class="flex flex-col bg-blue px-6 py-2 justify-center cursor-pointer font-semibold rounded-sm text-white text-sm hover:shadow-md">Yes</div>
                  <div v-on:click="closeLogoutOverlay()" class="flex flex-col border-grey-lightest border-solid border ml-4 px-4 py-2 justify-center font-semibold cursor-pointer rounded-sm text-grey-dark text-sm hover:shadow-md">No</div>
              </div>
          </div>
      </div>
    </div>
    <div id="overlay" v-if="showNotification" @click="toggleNotification()" style="position: fixed; width: 100%; height: 100%; top: 0; left: 0; right: 0; bottom: 0; background-color: rgba(0,0,0,0); z-index: 10; cursor: pointer;"></div>
    <doctor-notification v-if="showNotification" @enquireNow='enquireNow'/>
    <div v-if="showQueryPopUp" id="overlay" @click="closeQueryPopUp()" style="position: fixed; width: 100%; height: 100%; top: 0; left: 0; right: 0; bottom: 0; background-color: rgba(0,0,0,0.5); z-index: 10; cursor: pointer;"></div>
    <div v-if="showQueryPopUp" class="absolute flex flex-col bg-white shadow rounded-sm h-auto z-20" style="width: 380px; height: 300px; left: calc((108vw - 500px)/2); top:200px;z-index: 99;">
      <div class="flex flex-col justify-center px-4 py-2">
        <img class="flex self-center mt-8" src="../assets/pending_queries.svg" style="width:90px;">
          <div class="flex flex-row mb-2 justify-between items-center" style="position: absolute;bottom: 94px; left:31%">
              <div class="align-center text-lg text-left font-semibold py-2" style="color:#70411b">Pending Queries</div>
          </div>
          <label class="text-grey-darker font-light text-xs mx-8 text-center" style="position: absolute; bottom: 74px; left: 10px; text-align:center">
            You have pending queries from your patients. Please complete the conversations to close them.
          </label>
          <div class="flex flex-row mt-3 mb-5 justify-start" style="position: absolute;bottom: 0px; left:31%; margin-left: 38px;">
              <div @click="closeQueryPopUp()" class="flex flex-col bg-blue px-6 py-2 justify-center cursor-pointer rounded-sm text-white text-sm hover:shadow-md">Okay</div>
          </div>
      </div>
    </div>
  </div>
</template>

<script>
import router from '../router/index.js'
import ably from '../core/ably'
import {mapState, mapGetters} from 'vuex'
import doctor from '../api/doctor'
import DoctorNotification from '@/components/Notification/DoctorNotification'

export default {
  components: {
    DoctorNotification
  },
  data () {
    return {
      doctorName: sessionStorage.getItem('name'),
      currentStatus: sessionStorage.getItem('chatstatus') ? sessionStorage.getItem('chatstatus') : 'unavailable',
      company_id: JSON.parse(sessionStorage.getItem('company_id')),
      logOut: false,
      showNotification: false,
      showQueryPopUp: false
    }
  },
  computed: {
    ...mapGetters({
      doctor: 'configuration/doctor',
      role: 'configuration/getRole',
      activeConsultsCount: 'consultation/activeConsultsCount',
      notViewedNotificationCount: 'notification/getNotViewedCount',
      notification: 'notification/getLatestNotification',
      queries: 'consultationRequest/getQueries'
    }),
    ...mapState({
      connectivityStatus: state => state.configuration.connectivityStatus,
      availableForChat: state => state.configuration.availableForChat,
      isCompanyDoctor: state => state.configuration.isCompanyDoctor
    }),
    ablyStatus: function () {
      if (this.connectivityStatus === 'suspended' || this.connectivityStatus === 'failed') {
        return false
      } else {
        return true
      }
    },
    ablyDisconnected: function () {
      if (this.connectivityStatus === 'suspended' || this.connectivityStatus === 'failed' || this.connectivityStatus === 'disconnected' || this.connectivityStatus === 'not_connected') {
        return true
      } else {
        return false
      }
    },

    ablyConnected: function () {
      if (this.connectivityStatus === 'connected') {
        return true
      } else {
        return false
      }
    },

    ablyStatusText: function () {
      if (this.connectivityStatus === 'connecting') {
        return 'Connecting'
      } else if (this.connectivityStatus === 'connected') {
        return 'Connected'
      } else if (this.connectivityStatus === 'disconnected') {
        return 'Disconnected'
      } else {
        return 'Disconnected'
      }
    }
  },
  methods: {
    goHome: function () {
      if (window.location.pathname === '/home') {
        window.location.reload()
        return
      }
      window.location.href = '/home'
    },
    enquireNow: function (menu) {
      this.showNotification = false
    },
    closeQueryPopUp: function () {
      this.showQueryPopUp = false
    },
    updateActiveStatus: function (value) {
      let status = value ? 2 : 3
      doctor.activityStatus({status: status}).then(response => {
        let value = response.data.status.availability
        if (response.status === 200) {
          if (this.queries.length > 0 && value === true) {
            this.showQueryPopUp = true
          }
          this.$store.dispatch('configuration/setChatAvailability', value)
        }
      })
    },
    connectToAbly: function () {
      this.$store.dispatch('configuration/establishAblyConnection')
    },
    logoutClicked: function () {
      this.logOut = true
    },
    logout: function () {
      doctor.signout().then(response => {
        if (response.status === 200) {
          ably.close()
          this.$store.dispatch('clearAll')
          sessionStorage.clear()
          router.push({ path: 'login' })
        }
      })
    },
    closeLogoutOverlay: function () {
      this.logOut = false
    },
    toggleNotification: function () {
      this.showNotification = !this.showNotification
      if (this.showNotification && this.notification) {
        this.$store.dispatch('notification/updateViewed', this.notification.id)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
$black:hsl(0, 0%, 4%);
$grey: #666666;
$info: hsl(204, 86%, 53%);
.logo {
  width:110px;
  height:40px;
  background-image: url('../assets/ekincare.svg');
}
.columns {
  margin-top: 20px;
}
.dropdown {
  vertical-align: middle;
}
.navbar
{
  // box-shadow: 0px 4px 10px #888888;
  border-bottom: 1px solid #dbdbdb;
  background-color: #fafafa;
}

.db-menu-links {
  padding-top:15px;
}
.navbar-item, .navbar-link
{
  float:left;
  color:#4a4a4a;
  padding:0px 15px;
  font-size:13px;
  a {
    color:#4a4a4a;
  }
  a:hover {
    color:$info;
  }
}
.dropdownIcon {
    float: left;
    padding-right: 8px;
    font-size: 22px;
}
.db-avl-type
{
  padding-top:8px;
  span
  {
    font-size:13px;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/Navbar.vue